import { render, staticRenderFns } from "./CProfileDetailForCorporation.vue?vue&type=template&id=03877cf8&"
import script from "./CProfileDetailForCorporation.vue?vue&type=script&lang=ts&"
export * from "./CProfileDetailForCorporation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports